import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./PartyMenuUI.css";
import { FaCircle } from "react-icons/fa";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { BsThreeDots, BsCalendar2Date } from "react-icons/bs";
import { Link, useNavigate, useParams } from "react-router-dom";

import axios from "axios";
import { API_BASE_URL } from "../../utils";
import { BiSliderAlt } from "react-icons/bi";
import Loginpopup from "../../Navbar/Loginmodal";

import VenueAndPartyInfoCard from "./VenueAndPartyInfoCard";
import HeaderTitlewithBack from "../../TopTitle/HeaderTitlewithBack";
import InviteFriendModal from "../../BookingHistory/customComp/InviteFriendModal";
import referFriend from "../../Feed Page/image/refer-friend.svg";

const CATEGORY_DEFS = [
  {
    key: "starter",
    label: "Veg Starters",
    limitKey: "starter_choice",
    isVeg: true,
  },
  {
    key: "nonveg_starter",
    label: "Non-veg Starters",
    limitKey: "nonveg_starter_choice",
  },
  {
    key: "maincourse",
    label: "Veg Main Course",
    limitKey: "maincourse_choice",
    isVeg: true,
  },
  {
    key: "nonveg_maincourse",
    label: "Non-veg Main Course",
    limitKey: "nonveg_maincourse_choice",
  },
  {
    key: "rice",
    label: "Rice & Noodles",
    limitKey: "rice_choice",
    isVeg: true,
  },
  {
    key: "nonveg_rice",
    label: "Non-veg Rice & Noodles",
    limitKey: "nonveg_rice_choice",
  },
  { key: "breads", label: "Breads", limitKey: "breads_choice", isVeg: true },
  {
    key: "desserts",
    label: "Desserts",
    limitKey: "desserts_choice",
    isVeg: true,
  },
  {
    key: "nonveg_desserts",
    label: "Non-veg Desserts",
    limitKey: "nonveg_desserts_choice",
  },

  // Beverages
  { key: "whiskey", label: "Whiskey", limitKey: "whiskey_choice" },
  { key: "vodka", label: "Vodka", limitKey: "vodka_choice" },
  { key: "gin", label: "Gin", limitKey: "gin_choice" },
  { key: "rum", label: "Rum", limitKey: "rum_choice" },
  { key: "tequila", label: "Tequila", limitKey: "tequila_choice" },
  { key: "beer", label: "Beer", limitKey: "beer_choice" },
  { key: "red_wine", label: "Red Wine", limitKey: "red_wine_choice" },
  { key: "white_wine", label: "White Wine", limitKey: "white_wine_choice" },
  { key: "rose_wine", label: "Rosé Wine", limitKey: "rose_wine_choice" },
  {
    key: "sparkling_wine",
    label: "Sparkling Wine",
    limitKey: "sparkling_wine_choice",
  },
  { key: "mocktails", label: "Mocktails", limitKey: "mocktails_choice" },
  { key: "cocktails", label: "Cocktails", limitKey: "cocktails_choice" },
  { key: "juice", label: "Juice", limitKey: "juice_choice" },
  { key: "soft_drinks", label: "Soft Drinks", limitKey: "soft_drinks_choice" },
];

// Map CI keys to your payload keys (e.g., maincourse -> main_course)
const CAT_KEY_TO_PAYLOAD = {
  starter: "starter",
  nonveg_starter: "nonveg_starter",
  maincourse: "main_course",
  nonveg_maincourse: "nonveg_main_course",
  rice: "rice",
  nonveg_rice: "nonveg_rice",
  breads: "breads",
  desserts: "desserts",
  nonveg_desserts: "nonveg_desserts",
  whiskey: "whiskey",
  vodka: "vodka",
  gin: "gin",
  rum: "rum",
  tequila: "tequila",
  beer: "beer",
  red_wine: "red_wine",
  white_wine: "white_wine",
  rose_wine: "rose_wine",
  sparkling_wine: "sparkling_wine",
  mocktails: "mocktails",
  cocktails: "cocktails",
  juice: "juice",
  soft_drinks: "soft_drinks",
};

const TAB_GROUPS = {
  food: [
    "soups",
    "nonveg_soups",
    "starter",
    "nonveg_starter",
    "maincourse",
    "nonveg_maincourse",
    "rice",
    "nonveg_rice",
    "breads",
    "desserts",
    "nonveg_desserts",
  ],
  nonalc: ["juice", "soft_drinks", "mocktails"],
  alc: [
    "whiskey",
    "vodka",
    "gin",
    "rum",
    "tequila",
    "beer",
    "red_wine",
    "white_wine",
    "rose_wine",
    "sparkling_wine",
    "champagne",
    "cocktails",
  ],
};

const url = `${API_BASE_URL}/master/assets/uploads/`;

const parseLimit = (v) => {
  if (v === undefined || v === null) return 0;
  const s = String(v).trim();
  if (s.toLowerCase() === "all") return Infinity;
  const n = parseInt(s, 10);
  return Number.isNaN(n) ? 0 : n;
};

export default function PartyMenuUI() {
  const { id } = useParams(); // order_id from route
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState("food");
  const [selected, setSelected] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [openCats, setOpenCats] = useState({ starter: true });
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const [isFinalized, setIsFinalized] = useState(false);

  const userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : {};

  const [inviteFriendModal, setInviteFriendModal] = useState(false);

  // const userData = { id: 13298, };

  const handleFetchMenu = async (latitude, longitude) => {
    if (!id) return;
    setLoading(true);
    setError("");
    try {
      const formData = new FormData();
      formData.append("order_id", id);
      formData.append("user_id", userData.id);
      formData.append("latitude", latitude);
      formData.append("longitude", longitude);

      const response = await axios.post(
        `${API_BASE_URL}/master/APIs/ClubPackage/getMenuSelectionDetails`,
        formData
      );

      if (response?.data?.status) {
        const d = response.data.data || {};

        const hasFinal =
          d.finalized_menu &&
          typeof d.finalized_menu === "object" &&
          Object.keys(d.finalized_menu).length > 0;

        // normalize so the rest of your code can always read from data.menu
        const normalizedMenu = hasFinal ? d.finalized_menu || {} : d.menu || {};

        setIsFinalized(hasFinal);
        setData({ ...d, menu: normalizedMenu }); // overwrite .menu with whichever source we use
      } else {
        setError(response?.data?.msg || "Failed to load menu.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong while fetching the menu.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Get user location and fetch events
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLatitude(latitude.toString());
          setLongitude(longitude.toString());
          handleFetchMenu(latitude, longitude);
        },
        (error) => {
          // alert("Please enable Geo Location Service to find events in your locality.");
          console.error("Error in finding location: ", error);
        }
      );
    } else {
      console.error("Geolocation is not available in this browser.");
    }
  }, []);

  // Build only categories present in API and with non-empty arrays
  const categories = useMemo(() => {
    if (!data?.menu) return [];
    return CATEGORY_DEFS.map((def) => {
      const arr = Array.isArray(data.menu[def.key]) ? data.menu[def.key] : [];
      if (!arr.length) return null;
      const limit = parseLimit(data[def.limitKey]);
      return {
        ...def,
        items: arr,
        limit,
        rawLimit: data[def.limitKey],
      };
    }).filter(Boolean);
  }, [data]);

  useEffect(() => {
    if (categories.length && !activeTab) {
      setActiveTab(categories[0].key);
    }
  }, [categories, activeTab]);

  const getLimit = (catKey) => {
    const c = categories.find((x) => x.key === catKey);
    return c ? c.limit : 0;
  };

  const toggleItem = (catKey, itemName) => {
    setSelected((prev) => {
      const current = prev[catKey] || [];
      const exists = current.includes(itemName);

      if (exists) {
        const nextCat = current.filter((n) => n !== itemName);
        return { ...prev, [catKey]: nextCat };
      }

      const limit = getLimit(catKey);
      if (limit !== Infinity && limit > 0 && current.length >= limit) {
        alert(
          `Max ${limit} allowed in ${
            categories.find((c) => c.key === catKey)?.label || catKey
          }`
        );
        return prev;
      }

      const nextCat = [...current, itemName];
      return { ...prev, [catKey]: nextCat };
    });
  };

  /** Build payload exactly as backend expects */
  const buildPayload = () => {
    const menuArray = [];

    categories.forEach((c) => {
      const itemsToSend =
        c.limit === Infinity ? c.items : selected[c.key] || [];

      if (itemsToSend.length) {
        const rows = itemsToSend.map((itemObj) => ({
          user_id: userData?.id,
          item:
            typeof itemObj === "string"
              ? itemObj
              : itemObj.item || itemObj?.item?.item, // ✅ flatten nested object
        }));

        const payloadKey = CAT_KEY_TO_PAYLOAD[c.key] || c.key;
        menuArray.push({ [payloadKey]: rows });
      }
    });

    return {
      order_id: id,
      user_id: userData?.id,
      menu: menuArray,
    };
  };

  const isMenuComplete = useMemo(() => {
    return categories.every((cat) => {
      const chosen = selected[cat.key] || [];

      if (cat.limit === Infinity) return true;

      return chosen.length === cat.limit;
    });
  }, [categories, selected]);

  // Initialize selected from data.menu (if API returns pre-selections via raw.selected or raw.users includes current user)
  useEffect(() => {
    if (!categories.length) return;
    setSelected((prev) => {
      const next = { ...prev };

      categories.forEach((c) => {
        // If category is "All", preselect everything (same as before)
        if (c.limit === Infinity) {
          const names = c.items.map((raw) =>
            typeof raw === "string" ? raw : raw.item
          );
          next[c.key] = names;
          return;
        }

        // Otherwise, check for existing selections in data (raw.selected or users containing current user)
        const pre = [];
        c.items.forEach((raw) => {
          const name = typeof raw === "string" ? raw : raw.item;
          // raw.selected flag OR raw.users include current user (by id) OR raw.users length > 0? keep mostly raw.selected or user match
          const selectedFlag = raw.selected === true;
          const userPicked =
            Array.isArray(raw.users) &&
            raw.users.some((u) => String(u?.id) === String(userData?.id));
          if (selectedFlag || userPicked) {
            pre.push(name);
          }
        });

        // If previously had values keep them, otherwise set pre if any
        if ((!next[c.key] || next[c.key].length === 0) && pre.length > 0) {
          next[c.key] = pre;
        } else if (!next[c.key]) {
          next[c.key] = [];
        }
      });

      return next;
    });
  }, [categories, userData?.id]);

  const handleSubmit = async () => {
    if (!id || !categories.length) return;

    if (!isMenuComplete) {
      alert("Please select all items.");
      return;
    }

    let payload;
    try {
      payload = buildPayload();
    } catch (e) {
      alert(e.message || "Cannot build payload.");
      return;
    }

    setSaving(true);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/master/APIs/ClubPackage/saveGroupBookingItems`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (res?.data?.status) {
        alert("Menu saved successfully!");
        // refetch to get updated server state (could include newly saved selections)
        handleFetchMenu(latitude, longitude);
      } else {
        alert(res?.data?.msg || "Failed to save menu.");
      }
    } catch (e) {
      console.error(e);
      alert("Something went wrong while saving.");
    } finally {
      setSaving(false);
    }
  };

  const handleLogin = useCallback((ud) => {
    if (ud) {
      localStorage.setItem("userData", JSON.stringify(ud));
      window.location.reload();
      setShowLoginPopup(false);
    }
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    if (!userData) {
      setShowLoginPopup(true);
    }
  }, []);

  // Helper: build preview entries from `selected` for Updated Menu when not finalized
  const selectedPreviewByCategory = useMemo(() => {
    const out = [];
    if (!categories.length) return out;
    categories.forEach((c) => {
      const names = selected[c.key] || [];
      if (!names || names.length === 0) return;
      // map names to objects (try to find original raw item for display properties)
      const items = names.map((nm) => {
        const found = c.items.find((raw) => {
          const name = typeof raw === "string" ? raw : raw.item;
          return name === nm;
        });
        return {
          name: nm,
          raw: found || nm,
        };
      });
      out.push({ ...c, previewItems: items });
    });
    return out;
  }, [categories, selected]);

  return (
    <>
      {showLoginPopup && <Loginpopup clbk={handleLogin} isbackendUrl={true} />}
      <div className="pmu-app">
        <header className="agl-header">
          <HeaderTitlewithBack
            title={data?.package_title_name || "Customize Your Package"}
          />
        </header>
        <div className="pmu-grid">
          {/* Left column */}
          <div className="pmu-left">
            {/* Header */}

            {/* Venue Card */}
            <section className="pmu-card pmu-venue">
              <VenueAndPartyInfoCard data={data} />
            </section>

            {/* updated menu */}
            <div>
              <div className="pmu-menu surface">
                <div className="pmu-menu-head">
                  <h2>Updated Menu</h2>
                </div>

                {/* Tabs */}
                <div className="pmu-tabs">
                  <button
                    className={`pmu-tab ${
                      activeTab === "food" ? "is-active" : ""
                    }`}
                    onClick={() => setActiveTab("food")}>
                    Food Menu
                  </button>
                  <button
                    className={`pmu-tab ${
                      activeTab === "nonalc" ? "is-active" : ""
                    }`}
                    onClick={() => setActiveTab("nonalc")}>
                    Non-Alcoholic
                  </button>
                  <button
                    className={`pmu-tab ${
                      activeTab === "alc" ? "is-active" : ""
                    }`}
                    onClick={() => setActiveTab("alc")}>
                    Alcoholic
                  </button>
                </div>

                {/* Updated menu content:
                                    - If finalized: show categories from data.menu (finalized menu) as read-only
                                    - If not finalized: show user's selected items (preview) concurrently,
                                      and show "Done" badge when category reaches its max
                                */}
                <div className="pmu-accordions">
                  {isFinalized ? (
                    // Show finalized menu (read-only)
                    categories
                      .filter((cat) => TAB_GROUPS[activeTab]?.includes(cat.key))
                      .map((cat) => {
                        const isOpen = openCats[cat.key];
                        const pad2 = (n) => String(n).padStart(2, "0");
                        return (
                          <div className="pmu-acc" key={cat.key}>
                            <div
                              className="pmu-acc-head"
                              onClick={() =>
                                setOpenCats((s) => ({
                                  ...s,
                                  [cat.key]: !s[cat.key],
                                }))
                              }>
                              <div className="pmu-acc-title">
                                {cat.label}
                                <span className="pmu-acc-count">
                                  {cat.limit === Infinity
                                    ? "(All)"
                                    : `(${pad2(cat.items.length)}/${pad2(
                                        cat.limit
                                      )})`}
                                </span>
                              </div>
                              <div>
                                {isOpen ? (
                                  <FaChevronUp color="#6b7280" />
                                ) : (
                                  <FaChevronDown color="#6b7280" />
                                )}
                              </div>
                            </div>

                            {isOpen && (
                              <div className="pmu-acc-body">
                                {cat.items.map((raw, idx) => {
                                  const name =
                                    typeof raw === "string" ? raw : raw.item;
                                  return (
                                    <div className="pmu-row" key={idx}>
                                      <div className="pmu-item-wrap">
                                        <img
                                          className="pmu-thumb"
                                          src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600"
                                          alt={name}
                                        />
                                        <div className="pmu-col">
                                          <h5 className="pmu-item-title">
                                            {cat.isVeg && (
                                              <span className="pmu-badge-veg">
                                                <FaCircle />
                                              </span>
                                            )}
                                            {name}
                                          </h5>
                                          <p className="pmu-sub">
                                            Enjoy a refresh…
                                          </p>
                                        </div>
                                      </div>
                                      <span>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none">
                                          <rect
                                            x="0.625"
                                            y="0.625"
                                            width="18.75"
                                            height="18.75"
                                            rx="4.375"
                                            fill="#7464E4"
                                          />
                                          <rect
                                            x="0.625"
                                            y="0.625"
                                            width="18.75"
                                            height="18.75"
                                            rx="4.375"
                                            stroke="#7464E4"
                                            stroke-width="1.25"
                                          />
                                          <path
                                            d="M7.99766 12.4211L5.39141 9.81484L4.50391 10.6961L7.99766 14.1898L15.4977 6.68984L14.6164 5.80859L7.99766 12.4211Z"
                                            fill="#FEFBFF"
                                          />
                                        </svg>
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        );
                      })
                  ) : (
                    // Not finalized: show user's current selections preview with Done badge when limit is reached
                    <>
                      {selectedPreviewByCategory.length ? (
                        selectedPreviewByCategory
                          .filter((cat) =>
                            TAB_GROUPS[activeTab]?.includes(cat.key)
                          )
                          .map((cat) => {
                            const isOpen = openCats[cat.key];
                            const chosen = selected[cat.key] || [];
                            const isDone =
                              (cat.limit !== Infinity &&
                                chosen.length >= cat.limit) ||
                              (cat.limit === Infinity &&
                                chosen.length === cat.items.length);
                            return (
                              <div className="pmu-acc" key={cat.key}>
                                <div
                                  className="pmu-acc-head"
                                  onClick={() =>
                                    setOpenCats((s) => ({
                                      ...s,
                                      [cat.key]: !s[cat.key],
                                    }))
                                  }>
                                  <div className="pmu-acc-title">
                                    {cat.label}
                                    {isDone && (
                                      <span
                                        className="pmu-done-badge"
                                        style={{
                                          padding: "2px 8px",
                                          borderRadius: 12,
                                          background: "#3cbd5419",
                                          color: "#3CBD53",
                                          fontSize: 12,
                                        }}>
                                        Done
                                      </span>
                                    )}
                                    <span className="pmu-acc-count">
                                      (
                                      {String(cat.previewItems.length).padStart(
                                        2,
                                        "0"
                                      )}
                                      )
                                    </span>
                                  </div>
                                  <div>
                                    {isOpen ? (
                                      <FaChevronUp color="#6b7280" />
                                    ) : (
                                      <FaChevronDown color="#6b7280" />
                                    )}
                                  </div>
                                </div>

                                {isOpen && (
                                  <div className="pmu-acc-body">
                                    {cat.previewItems.map((it, idx) => (
                                      <div
                                        className="pmu-row position-relative"
                                        key={idx}>
                                        <div className="pmu-item-wrap">
                                          <img
                                            className="pmu-thumb"
                                            src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600"
                                            alt={it.name}
                                          />
                                          <div className="pmu-col">
                                            <h5 className="pmu-item-title">
                                              {cat.isVeg && (
                                                <span className="pmu-badge-veg">
                                                  <FaCircle />
                                                </span>
                                              )}
                                              {it.name}
                                            </h5>
                                            <p className="pmu-sub">
                                              Selected by you
                                            </p>
                                          </div>
                                        </div>
                                        <div className="check-box-menu">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none">
                                            <rect
                                              x="0.625"
                                              y="0.625"
                                              width="18.75"
                                              height="18.75"
                                              rx="4.375"
                                              fill="#7464E4"
                                            />
                                            <rect
                                              x="0.625"
                                              y="0.625"
                                              width="18.75"
                                              height="18.75"
                                              rx="4.375"
                                              stroke="#7464E4"
                                              stroke-width="1.25"
                                            />
                                            <path
                                              d="M7.99766 12.4211L5.39141 9.81484L4.50391 10.6961L7.99766 14.1898L15.4977 6.68984L14.6164 5.80859L7.99766 12.4211Z"
                                              fill="#FEFBFF"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            );
                          })
                      ) : (
                        <div className="pmu-empty">
                          <p>
                            No selections yet. Use the "Customize Your Menu"
                            panel to select your items — they will appear here
                            as you choose them.
                          </p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Right column */}
          <aside className="pmu-right">
            {/* Hide Customize panel when finalized as per requirement */}
            {!isFinalized ? (
              <div className="pmu-menu surface">
                <div className="pmu-menu-head">
                  <h2>Customize Your Menu</h2>
                  <div className="pmu-head-actions">
                    <button className="pmu-icon-btn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="17"
                        viewBox="0 0 21 17"
                        fill="none">
                        <path
                          d="M19.0388 8L13.875 2.83625V5.60375L12.9075 5.75C8.05875 6.43625 4.77375 8.97875 2.895 12.8712C5.505 11.0262 8.745 10.1375 12.75 10.1375H13.875V13.1638M11.625 11.285C6.59625 11.5213 2.99625 13.3325 0.375 17C1.5 11.375 4.875 5.75 12.75 4.625V0.125L20.625 8L12.75 15.875V11.2625C12.3787 11.2625 12.0075 11.2738 11.625 11.285Z"
                          fill="#4F4F4F"
                        />
                      </svg>
                    </button>
                    {/* <button className="pmu-icon-btn">
                      <BsThreeDots />
                    </button> */}
                  </div>
                </div>

                {/* Tabs */}
                <div className="pmu-tabs">
                  <button
                    className={`pmu-tab ${
                      activeTab === "food" ? "is-active" : ""
                    }`}
                    onClick={() => setActiveTab("food")}>
                    Food Menu
                  </button>
                  <button
                    className={`pmu-tab ${
                      activeTab === "nonalc" ? "is-active" : ""
                    }`}
                    onClick={() => setActiveTab("nonalc")}>
                    Non-Alcoholic
                  </button>
                  <button
                    className={`pmu-tab ${
                      activeTab === "alc" ? "is-active" : ""
                    }`}
                    onClick={() => setActiveTab("alc")}>
                    Alcoholic
                  </button>
                </div>

                {/* Accordions (filtered by tab) */}
                <div className="pmu-accordions">
                  {categories
                    .filter((cat) => TAB_GROUPS[activeTab]?.includes(cat.key))
                    .map((cat) => {
                      const chosen = selected[cat.key] || [];
                      const limitHit =
                        chosen.length >= cat.limit && cat.limit !== Infinity;
                      const isOpen = openCats[cat.key];
                      const pad2 = (n) => String(n).padStart(2, "0");

                      return (
                        <div className="pmu-acc" key={cat.key}>
                          <div
                            className="pmu-acc-head"
                            onClick={() =>
                              setOpenCats((s) => ({
                                ...s,
                                [cat.key]: !s[cat.key],
                              }))
                            }>
                            <div className="pmu-acc-title">
                              {cat.label}
                              <span className="pmu-acc-count">
                                {cat.limit === Infinity
                                  ? "(All)"
                                  : `(${pad2(chosen.length)}/${pad2(
                                      cat.limit
                                    )})`}
                              </span>
                            </div>
                            <div>
                              {!isFinalized && <></>}
                              {isOpen ? (
                                <FaChevronUp color="#6b7280" />
                              ) : (
                                <FaChevronDown color="#6b7280" />
                              )}
                            </div>
                          </div>

                          {isOpen && (
                            <div className="pmu-acc-body">
                              {cat.items.map((raw, idx) => {
                                const name =
                                  typeof raw === "string" ? raw : raw.item;
                                const checked = chosen.includes(name);
                                return (
                                  <div className="pmu-row" key={idx}>
                                    {Array.isArray(raw.users) &&
                                      raw.users.length > 0 && (
                                        <div className="pmu-item-users-count-wrap">
                                          <div className="pmu-item-users-profile">
                                            {(
                                              raw.users[0]?.name?.split(
                                                " "
                                              )[0]?.[0] || "U"
                                            ).toUpperCase()}
                                          </div>
                                          <p>
                                            {raw.users?.length > 0
                                              ? raw.users[0]?.name?.split(
                                                  " "
                                                )[0] || "User"
                                              : "User"}
                                          </p>
                                          {raw.users.length > 1 && (
                                            <span>
                                              & {raw.users.length - 1}+
                                            </span>
                                          )}
                                        </div>
                                      )}
                                    <div className="pmu-item-wrap">
                                      <img
                                        className="pmu-thumb"
                                        src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600"
                                        alt={name}
                                      />
                                      <div className="pmu-col">
                                        <h5 className="pmu-item-title">
                                          {cat.isVeg && (
                                            <span className="pmu-badge-veg">
                                              <FaCircle />
                                            </span>
                                          )}
                                          {name}
                                        </h5>
                                        <p className="pmu-sub">
                                          Enjoy a refresh…
                                        </p>
                                        <button className="pmu-link">
                                          View More
                                        </button>
                                      </div>
                                      <label className="pmu-check">
                                        {!isFinalized && (
                                          <input
                                            type="checkbox"
                                            checked={checked}
                                            onChange={() =>
                                              toggleItem(cat.key, name)
                                            }
                                          />
                                        )}
                                        <span className="pmu-checkmark" />
                                      </label>
                                    </div>
                                  </div>
                                );
                              })}

                              {limitHit && (
                                <div className="pmu-limit">
                                  Maximum limit reached – only {cat.limit}{" "}
                                  selections allowed.
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>

                {/* Footer actions */}
                <div className="pmu-footer">
                  {!isFinalized && (
                    <button
                      className={`pmu-btn pmu-btn-primary ${
                        !isMenuComplete ? "pmu-is-disabled" : ""
                      }`}
                      style={{ width: "100%" }}
                      onClick={handleSubmit}
                      disabled={saving || !isMenuComplete}>
                      {saving ? "Saving…" : "Submit Menu"}
                    </button>
                  )}
                  {id && (
                    <Link to={`/add-guest/${id}`} style={{ width: "100%" }}>
                      <button className="pmu-btn pmu-btn-link">
                        Next: Add Guests
                      </button>
                    </Link>
                  )}
                </div>
              </div>
            ) : (
              <div className="pmu-finished-menu">
                <div className="pmu-finished-menu-title">
                  <h5>Invite Your Accompany </h5>
                  <h6>
                    Total: {Number(data?.male_qty) + Number(data?.female_qty)}
                  </h6>
                </div>
                <div className="pmu-finished-menu-guest-card">
                  <div className="pfmgc-wrap-male">
                    <h1>{data?.male_qty}</h1>
                    <p>Male</p>
                  </div>
                  <div className="pfmgc-wrap-female">
                    <h1>{data?.female_qty}</h1>
                    <p>Female</p>
                  </div>
                </div>
                <div className="pmu-finished-menu-divider-btn">
                  <button onClick={() => navigate(`/add-guest/${id}`)}>
                    Update Guest List
                  </button>
                </div>
              </div>
            )}

            {userData !== null && (
              <div
                className="upcoming-events-referr-a-friend"
                style={{
                  backgroundImage: `url(${referFriend})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundOpacity: "0.7",
                }}>
                <h3>Refer & Earn</h3>
                <p>
                  Share the party vibes with your friends and collect carrots
                  every time they join in. More carrots = more savings on your
                  next night out!{" "}
                </p>
                <button onClick={() => setInviteFriendModal(true)}>
                  Invite Friend
                </button>
              </div>
            )}
          </aside>
        </div>
      </div>

      <InviteFriendModal
        isOpen={inviteFriendModal}
        onClose={() => setInviteFriendModal(false)}
      />
    </>
  );
}
